import RenderManager from "../rendering/render-manager";
import SlideManager from "../utils/slide-manager";

let lastHighlight = { object: null, color: null, label: null, is2d: false };

function highlightObject(newHighlightObject, labelToHighlight, is2d) {

    if (lastHighlight.object && lastHighlight.is2d && !is2d && lastHighlight.object !== newHighlightObject) return;

    const data = newHighlightObject && SlideManager.currentSlide.animation[newHighlightObject.uuid];

    if (newHighlightObject && "disableInteractivity" in data && data.disableInteractivity)
        return;

    if (lastHighlight.object !== newHighlightObject) {
        //Reset previous highlighted object
        if (lastHighlight.object && (!Q3.data.assets.objects[lastHighlight.object.uuid] || objectHighlightingSet(lastHighlight.object.uuid))) {
            RenderManager.setHighlightObjects();
        }

        //Highlight new Object
        if (newHighlightObject &&
            newHighlightObject.visible &&
            (!Q3.data.assets.objects[newHighlightObject.uuid]
                || objectHighlightingSet(newHighlightObject.uuid))) {
            RenderManager.setHighlightObjects([newHighlightObject]);
        }

        lastHighlight.object = newHighlightObject;
        RenderManager.activeCamera.update = true;
    }


    if (Q3.labels.live.highlighted !== labelToHighlight) {
        if (!labelToHighlight && Q3.labels.live.highlighted /*&& Q3.labels.live.highlighted === lastHighlight.label*/) {
            Q3.labels.live.setHighlightLabel(Q3.labels.live.highlighted, false, is2d);
        }

        if (labelToHighlight) {
            Q3.labels.live.setHighlightLabel(labelToHighlight, true, is2d);
        }

        lastHighlight.label = labelToHighlight;
    }

    lastHighlight.is2d = is2d;
}

function objectHighlightingSet(uuid) {
    return Q3.selectingMesh || Q3.data.assets.objects[uuid].highlight || SlideManager.currentSlide.animation[uuid].highlight;
}

export default highlightObject;
export { highlightObject }